import React from 'react';
import { Checkbox } from '@mui/material';
import { FormControlLabel } from '@mui/material';


const CheckboxProton = ({ changeChecked, values }) => {
  const { checked, label, id } = values;
  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            size='small'
            checked={checked}
            onChange={() => changeChecked(id)}
            inputProps={{ 'aria-label': 'checkbox with small size' }}
          />
        }
        label={label}
      />
    </div>
  );
};

export default CheckboxProton;